<mat-dialog-content>
  <div class="container p-2 align-middle">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-close" (click)="onNoClick()">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>
    <div class="row mt-3 justify-content-center">
      <div class="col-auto" *ngIf="isPdf(type)">
        <pdf-viewer [src]="url" [render-text]="true" [original-size]="false"
          style="width: 80vw; max-width: 900px; height: 90vh">
        </pdf-viewer>
      </div>
      <div class="col-auto" *ngIf="isImg(type)">
        <img [src]="url">
      </div>
      <div class="col-12" style="max-width: 900px;" *ngIf="isVideo(type)">
        <vm-player>
          <vm-video cross-origin="true">
            <source [src]="url" [type]="type" />
          </vm-video>
          <vm-default-ui no-click-to-play>
          </vm-default-ui>
        </vm-player>
      </div>
    </div>
  </div>
</mat-dialog-content>